/* unplugin-vue-components disabled */import { render } from "./TeacherCard.vue?vue&type=template&id=564745a2&scoped=true"
import script from "./TeacherCard.vue?vue&type=script&lang=js"
export * from "./TeacherCard.vue?vue&type=script&lang=js"

import "./TeacherCard.vue?vue&type=style&index=0&id=564745a2&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户山农大-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564745a2"]])

export default __exports__